import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, AlertTriangle, MapPin } from 'lucide-react';

export default function NotFound() {
  useEffect(() => {
    // HTTP status code meta tag'ini ekle
    const meta = document.createElement('meta');
    meta.httpEquiv = 'status';
    meta.content = '404';
    document.head.appendChild(meta);

    // SEO için title güncelle
    document.title = '404 - En Yakın Taksi';

    // Cleanup
    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1d24] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-[#24272e] rounded-2xl p-8 shadow-xl border border-white/5">
          <div className="flex flex-col items-center text-center gap-6">
            <div className="p-4 bg-red-500/10 rounded-2xl">
              <AlertTriangle className="w-12 h-12 text-red-400" />
            </div>
            
            <div>
              <h1 className="text-3xl font-bold text-white mb-2">404</h1>
              <p className="text-gray-400">
                Aradığınız sayfa bulunamadı. Ana sayfaya dönebilir ve en yakın taksiyi bulabilirsiniz.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full">
              <Link
                to="/"
                className="flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-gray-900 font-semibold rounded-xl transition-colors"
              >
                <Home className="w-5 h-5" />
                <span>Ana Sayfa</span>
              </Link>

              <Link
                to="/"
                className="flex items-center justify-center gap-2 px-6 py-3 bg-[#1a1d24] hover:bg-[#2d3039] text-white font-semibold rounded-xl transition-colors border border-white/10"
              >
                <MapPin className="w-5 h-5" />
                <span>En Yakın Taksi Bul</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}